<template>
    <div class="add-to-watchlist-button">
        <div
            :class="['add-to-watchlist-button__icons', alignment]"
            v-on:click.stop.prevent="toggle"
            @keyup.enter="toggle"
            tabindex="0"
        >
            <span class="icon-bookmark"  v-tooltip="{ content: $t(toolTipText), html: true }" v-if="isElementInAnyWatchList" :class="{ active: isElementInAnyWatchList }"></span>
            <span class="icon-bookmark-outline-add" v-tooltip="{ content: $t(toolTipText), html: true }" v-else :class="{ active: isElementInAnyWatchList }"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import watchlistHelper from 'components/shared/global-courses-items/helper/watchlist-helper'

    export default {
        name: 'totem-add-to-watchlist-button',
        mixins: [ watchlistHelper ],
        props: {
            alignment: {
                type: String,
                validator: (prop) => [ 'top', 'bottom' ].includes(prop),
                default: 'top'
            },
            elementId: Number,
            type: {
                type: String,
                default: 'course'
            },
            isVertical: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                delayAfterClosingModal: false
            }
        },
        computed: {
            ...mapGetters({
                isModalOpen: 'Watchlists/isModalOpen',
                getCurrentMenuOpened: 'Watchlists/getCurrentMenuOpened',
                isLoggedIn: 'isLoggedIn'
            }),
            toolTipText () {
                switch (this.type) {
                    case 'course':
                        return this.$t('TotemAddToFavourite.add_course')
                    case 'learningPath':
                        return this.$t('TotemAddToFavourite.add_learning_path')
                    case 'collection':
                        return this.$t('TotemAddToFavourite.add_collection')
                }
                return this.$t('TotemAddToFavourite.add_course')
            },
            isElementInAnyWatchList () {
                return this.watchlists.find(watchList => watchList.collection.find(id => +id === +this.elementId))
            },
            isMenuOpen () {
                return +this.getCurrentMenuOpened === +this.elementId
            }
        },
        methods: {
            async toggle () {
                if (this.isLoggedIn) {
                    if (!this.isMenuOpen) {
                        await this.$store.dispatch('Watchlists/openMenu', this.elementId)
                        await this.$store.dispatch('Watchlists/setType', this.type)
                        this.$modal.show('add-to-watchlist-modal')
                    }
                } else {
                    this.$modal.hide('add-to-watchlist-modal')
                    this.$router.push({ name: 'login' })
                }
            },
            showAddedToNewWatchlist (title) {
                this.toastRef.show(this.$t('TotemAddToFavourite.added_to_new_watchlist') + ` ${title}`)
            },
            isInWatchList (list) {
                return list.find(id => +id === +this.elementId)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add-to-watchlist-button {
        z-index: 200;
        font-size: 1.4rem;

        &:hover {
            .icon-bookmark.active,
            .icon-bookmark-outline-add,
            .icon-bookmark-outline-add.active {
                opacity: 0.9;
            }
        }

        .icon-bookmark, .icon-bookmark-outline-add {
            color: $astral;
        }

        .icon-bookmark,
        .icon-bookmark-outline-add {
            font-size: 2.5rem;
        }

        &__icons {
            z-index: 1000;

            &.top {
                padding: 37px 23px 20px 23px;
                top: 0;
                right: 5px;
                position: absolute;
                z-index: 1;

                [class*="mobile_sm"] & {
                    padding: 34px 20px 20px;
                }
            }
        }

        &__cancel-icon {
            display: flex;
            align-items: center;
            line-height: 12px;
            justify-content: center;

            .icon-cancel {
                font-size: 2.4rem;
            }
        }
    }
</style>
